import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-instructors-page-two',
  templateUrl: './instructors-page-two.component.html',
  styleUrls: ['./instructors-page-two.component.scss']
})
export class InstructorsPageTwoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
